export const rajabFirst10Days = {
  label: 'Rajab',
  startDate: '2025-01-01',
  endDate: '2025-01-30',
  hourOfDonation: 16,
  interval: 1,
};

export const fridays = {
  label: 'Fridays',
  startDate: '2025-01-03',
  endDate: '2035-12-26',
  hourOfDonation: 16,
  interval: 7,
};

export const oneTime = () => {
  const now = new Date();
  return {
    label: 'One Time',
    startDate: now.toISOString().split('T')[0],
    endDate: now.toISOString().split('T')[0],
    hourOfDonation: now.getHours(),
    interval: 1,
  };
};

export const ramadanHijri = {
  label: 'Hijri',
  startDate: '2025-02-28',
  endDate: '2025-03-29',
  hourOfDonation: 22,
  interval: 1,
};

export const ramadanLunar = {
  label: 'Lunar',
  startDate: '2025-03-01',
  endDate: '2025-03-30',
  hourOfDonation: 22,
  interval: 1,
};

export const ramadanHijri10 = {
  label: 'Hijri10',
  startDate: '2025-03-20',
  endDate: '2025-03-29',
  hourOfDonation: 22,
  interval: 1,
};

export const ramadanLunar10 = {
  label: 'Lunar10',
  startDate: '2025-03-21',
  endDate: '2025-03-30',
  hourOfDonation: 22,
  interval: 1,
};

export const test = {
  label: 'Test',
  startDate: '2025-02-01',
  endDate: '2025-02-27',
  hourOfDonation: 12,
  interval: 1,
};
